<template>
  <button class="back-button" @click="handleClick">
    <span class="back-icon">←</span>
    <span class="back-text">{{ text }}</span>
  </button>
</template>

<script>
export default {
  name: 'BackButton',
  props: {
    // 按钮文字，默认为"返回列表"
    text: {
      type: String,
      default: '返回列表'
    }
  },
  methods: {
    handleClick() {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
.back-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background-color: transparent;
  color: $primary-color;
  border: 1px solid $primary-color;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  font-family: inherit;

  &:hover {
    background-color: $primary-color;
    color: #ffffff;
    transform: translateX(-4px);
  }

  &:active {
    opacity: 0.8;
  }

  .back-icon {
    font-size: 18px;
    font-weight: bold;
    line-height: 1;
  }

  .back-text {
    line-height: 1;
  }
}

// 响应式设计
@media screen and (max-width: 768px) {
  .back-button {
    padding: 8px 16px;
    font-size: 13px;

    .back-icon {
      font-size: 16px;
    }
  }
}
</style>

